/**
 * @generated SignedSource<<7fb2e95d234041c0053f4fb4fffedb0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberModalSelectedMember_Member$data = {
  readonly email: string | null | undefined;
  readonly firstName: string | null | undefined;
  readonly id: string;
  readonly lastName: string | null | undefined;
  readonly phoneNumber: {
    readonly nationalNumber: string;
  } | null | undefined;
  readonly profileImage: {
    readonly publicId: string;
  } | null | undefined;
  readonly " $fragmentType": "MemberModalSelectedMember_Member";
};
export type MemberModalSelectedMember_Member$key = {
  readonly " $data"?: MemberModalSelectedMember_Member$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberModalSelectedMember_Member">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberModalSelectedMember_Member",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "profileImage",
      "plural": false,
      "selections": [
        {
          "alias": "publicId",
          "args": null,
          "kind": "ScalarField",
          "name": "renderingKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhoneNumber",
      "kind": "LinkedField",
      "name": "phoneNumber",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nationalNumber",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Member",
  "abstractKey": null
};

(node as any).hash = "17852b786e1c9f31f4c3fdb3d01431db";

export default node;
